import { getData } from "../../api";


export const BlogCategoryData = async (id) => {
    try {
        return await getData(`/without-login/blog/category`);
    } catch (error) {
        console.log(error);
    }
}


export const InnerBlogCategoryData = async (id,onPageChange) => {
    try {
        return await getData(`/without-login/blog/category-blog/${id}?page=${onPageChange}`);
    } catch (error) {
        console.log(error);
    }
}


export const SingleBlogData = async (id) => {
    try {
        return await getData(`/without-login/blog/${id}`);
    } catch (error) {
        console.log(error);
    }
}